import React from 'react'
import { TabSelect } from '../../components/generics/TabSelect'
import {componentsAndNamesByUserPath } from '../../services/componentsAndNamesByPaths.service'

export const UserPage = (props) => {

    let listContentTab = componentsAndNamesByUserPath(props.history.location.pathname, props.match.params.id);

    return (
        <>
            <TabSelect
            listContentTab={listContentTab}
            /> 
        </>
    )
}
